var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "text-start": "",
      "font-weight": 600,
      "font-size": 14,
      "title": "Документ о достижении",
      "append-icon": "mdi-trash-can-outline"
    },
    on: {
      "click:append-outer": _vm.removeAchievement
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setAchievement
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Наименование")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.achievement.name,
      callback: function callback($$v) {
        _vm.$set(_vm.achievement, "name", $$v);
      },
      expression: "achievement.name"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setAchievement
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Серия")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.achievement.series,
      callback: function callback($$v) {
        _vm.$set(_vm.achievement, "series", $$v);
      },
      expression: "achievement.series"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setAchievement
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Номер")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.achievement.number,
      callback: function callback($$v) {
        _vm.$set(_vm.achievement, "number", $$v);
      },
      expression: "achievement.number"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('DatePicker', {
    attrs: {
      "label": "Дата выдачи",
      "required": "",
      "prop-date": _vm.achievement.issueDate
    },
    on: {
      "set-date": _vm.setIssueDate
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setAchievement
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Кем выдан")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.achievement.issueBy,
      callback: function callback($$v) {
        _vm.$set(_vm.achievement, "issueBy", $$v);
      },
      expression: "achievement.issueBy"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('FileInput', {
    attrs: {
      "title": "Файл документа о достижении",
      "ref-id": _vm.achievement.id,
      "ref-class-name": "Achievement"
    },
    on: {
      "set-files": _vm.setFiles
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }